import { Formik } from 'formik';
import * as PropTypes from 'prop-types';
import { object, string } from 'yup';

const initialValues = {
    username: '',
    password: '',
    token: '',
};

const validationSchema = object().shape({
    username: string().email().required('You should enter an email as username.'),
    password: string().min(8, 'Password should be at least 8 characters long.').required('You should enter password.'),
    token: string(),
});

const FormWrapper = (props) => {
    const { children, onSubmit } = props;

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {children}
        </Formik>
    );
};

FormWrapper.propTypes = {
    children: PropTypes.node.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default FormWrapper;
